/**
 * The identity verification request timeout.
 */
export const IDENTITY_VERIFICATION_REQUEST_TIMEOUT_IN_MS = 10000;

/**
 * Mapping source name to user friendly name.
 */
export const DOCUMENT_SOURCE_TO_LABEL_MAP = {
  actregodvs: "Driver's License",
  nswregodvs: "Driver's License",
  ntregodvs: "Driver's License",
  qldregodvs: "Driver's License",
  saregodvs: "Driver's License",
  tasregodvs: "Driver's License",
  vicregodvs: "Driver's License",
  waregodvs: "Driver's License",
  medicaredvs: 'Medicare Card',
  centrelinkdvs: 'Centrelink',
  passportdvs: 'Australian passport',
  visadvs: 'Australian visa',
  citizenshipcertificatedvs: 'Citizenship Certificate',
  immicarddvs: 'ImmiCard',
  birthcertificatedvs: 'Birth Certificate',
} as const;
